/*
 * Carte principale du bilan : profil, score global et acces a
 * l'explication du calcul. Donnees calculees localement (conservation nulle).
 */

import { motion } from "framer-motion";
import { ScoreExplanationDialog } from "@/components/bilan/ScoreExplanationDialog";
import { LOGO_WHITE, TAGLINE } from "@/lib/branding";

export const ProfileScoreCard = ({ result, baremeVersion }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: 0.08 }}
    className="relative mt-6 rounded-2xl bg-[#235277] p-6 sm:p-8 overflow-hidden gbs-grain"
  >
    <div className="absolute inset-0 gbs-lemon-halo pointer-events-none" aria-hidden="true" />
    <div className="relative mb-5">
      <img
        src={LOGO_WHITE}
        alt="Gino Body & Soul"
        className="h-8 w-auto opacity-90"
        data-testid="bilan-card-logo-image"
      />
      <p className="mt-1 text-[10px] font-medium text-[rgba(249,254,255,0.65)]">{TAGLINE}</p>
    </div>
    <div className="relative flex flex-col sm:flex-row sm:items-center gap-6">
      <div className="shrink-0">
        <div
          className="w-24 h-24 rounded-full border-4 border-[#EAFE63] flex items-center justify-center bg-[rgba(249,254,255,0.06)]"
          role="img"
          aria-label={`Score d'orientation : ${result.global_score ?? "non calcul\u00e9"} sur 100`}
        >
          <div className="text-center">
            <span className="font-heading block text-3xl font-bold text-white tabular-nums" data-testid="bilan-global-score">
              {result.global_score ?? "\u2026"}
            </span>
            <span className="text-[10px] font-medium text-[rgba(249,254,255,0.7)]">/ 100</span>
          </div>
        </div>
      </div>
      <div>
        <p className="text-sm leading-relaxed text-[rgba(249,254,255,0.92)]" data-testid="bilan-intro-text">{result.intro_text}</p>
        <p className="mt-3 text-xs leading-relaxed text-[rgba(249,254,255,0.65)]">{result.profile.description}</p>
      </div>
    </div>
    <div className="relative mt-5">
      <span className="[&_button]:text-[rgba(249,254,255,0.75)] [&_button:hover]:text-white">
        <ScoreExplanationDialog baremeVersion={baremeVersion} />
      </span>
    </div>
  </motion.div>
);
